import script from "./FollowWxDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./FollowWxDialog.vue?vue&type=script&lang=ts&setup=true"

import "./FollowWxDialog.vue?vue&type=style&index=0&id=05082458&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05082458"]])

export default __exports__